import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MismachimService } from 'src/app/services/mismachim.service';
import { TextService } from 'src/app/services/text.service';
import { EmailRadioValues } from '../teuda/teuda.component';
import { UserService } from 'src/app/services/user.service';
import { DeviceInfoService } from 'src/app/services/device-info.service';
import { decompress } from 'lz-string';
import { Order } from 'src/app/Interfaces/order';
import { Mismachim, MismachimEach, MismachimEachDuplicateResponse } from 'src/app/Interfaces/mismachim';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, combineLatest, map, Observable, startWith, Subject, take } from 'rxjs';
import { OrderState } from 'src/app/Interfaces/all-products';
import { SearchInputComponent } from '../search-input/search-input.component';
import { genericSearchingFunction, genericSearchingFunctionWithoutNullChecks } from 'src/app/Utility/functions';
import { Product } from 'src/app/Interfaces/product';

type MismachimEachWithItemPicName = MismachimEach & { ItemPicName?: string };

@Component({
	selector: 'app-mismachimeach',
	templateUrl: './mismachimeach.component.html',
	styleUrls: ['./mismachimeach.component.scss'],
})
export class MismachimeachComponent implements OnInit, AfterViewInit {
	@Input() mismachim: MismachimEach[] = [];
	@Input() productIDToScrollTo: string;
	@Input() doctypeName = '';
	@Input() Client_Name = '';
	@Input() Client_Id = '';
	@Input() ClientEmail = '';

	constructor(
		public _ss: StoreService,
		public router: Router,
		public _fb: FormBuilder,
		public _mismachim: MismachimService,
		public _text: TextService,
		public _user: UserService,
		public _device: DeviceInfoService,
	) {}

	public EachClientEachOrder: MismachimEachWithItemPicName[] = [];
	EachClientEachOrder$ = new BehaviorSubject<MismachimEachWithItemPicName[]>([]);

	@ViewChild(SearchInputComponent) searchInputComponent: SearchInputComponent;

	eachClientEachOrderDisplay$ = this.EachClientEachOrder$.asObservable();

	OneClientInfo = this._ss.OneClientInfo;

	addressToDisplay =
		this._ss.OneClientInfo?.Address && this._ss.OneClientInfo?.CustCity
			? `${this._ss.OneClientInfo.Address}, ${this._ss.OneClientInfo.CustCity}`
			: this._ss.OneClientInfo?.Address || this._ss.OneClientInfo?.CustCity || '';
	// If both undefined for some reason

	doesPDFExistInServer = false;
	pdfFolderLookup = this._ss.CustomerInformation.PDFDirectory;
	pdfFilepath;

	history = history;

	showItemInPack = true;

	isEmailPickPopupOpen = false;

	clientHasEmail = false;

	windowWidth = window.innerWidth;

	emailRadios = new FormControl<EmailRadioValues>('custom');
	emailInput = new FormControl('', [Validators.required, Validators.email]);

	doctypes$ = new BehaviorSubject<MismachimEachDuplicateResponse[]>([]);
	doctypeNames$ = new BehaviorSubject<{ [doctype: string]: string }>({});
	doctypeDisplay$ = combineLatest([this.doctypes$, this.doctypeNames$]).pipe(
		map(([doctypes, doctypeNames]) => Object.entries(doctypeNames).map(([doctype, doctypeName]) => ({ doctype, doctypeName, lines: doctypes }))),
	);
	anyDoctypesToDuplicate$ = this.doctypes$.pipe(map(doctype => doctype.length > 0));

	canDuplicate = this._ss.CustomerInformation.CanDuplicateMismachim === '1';
	public PopDuplicate = false;
	public ConfirmPop = false;

	custImageServer = this._ss.CustomerInformation.CustImageDomain;
	allProducts$ = new BehaviorSubject<Product[]>([]);
	allProductsRecord$ = this.allProducts$.pipe(
		map(products =>
			this._ss.AllProductsFromLocalStorageDictionaryByProductID
				? this._ss.AllProductsFromLocalStorageDictionaryByProductID
				: products.reduce((acc, product) => ({ ...acc, [product.ProductId]: product }), {}),
		),
	);

	isWholePage = location.pathname.includes('mismachim');
	showBackButton = this.isWholePage;

	ngOnInit(): void {
		if (this._ss.OneClientInfo === null && this.isWholePage) {
			this.router.navigate(['clients']);
			return;
		}

		this.Client_Name ||= this._ss.OneClientInfo?.Client_Name || '';
		this.Client_Id ||= this._ss.OneClientInfo?.ClientId || '';

		if (!this._ss.AllProductsFromLocalStorage) {
			const allProducts = localStorage.getItem('AllProducts');

			if (allProducts === null) {
				this.router.navigate(['clients']);
				return;
			}

			const parsed = JSON.parse(decompress(allProducts) ?? '[]');
			this.allProducts$.next(parsed);
			this._ss.AllProductsFromLocalStorage = parsed;
			this._ss.createAllProductsDictionary();
		} else {
			this.allProducts$.next(this._ss.AllProductsFromLocalStorage);
		}

		this.showItemInPack = this._ss.CustomerInformation.HideQuantityInPack !== '1';

		this.clientHasEmail = !!this.OneClientInfo?.CustEMail || !!this.OneClientInfo?.CustEmail || false;

		if (this.clientHasEmail) {
			this.emailRadios.setValue('client');
		}

		this.getEachClientEachOrder();
	}

	ngAfterViewInit(): void {
		if (this.productIDToScrollTo && window[this.productIDToScrollTo]) {
			const element = window[this.productIDToScrollTo] as HTMLElement;
			element.scrollIntoView({ behavior: 'auto', block: 'center' });
		}
		if (!this.searchInputComponent) return;
		this.eachClientEachOrderDisplay$ = combineLatest([this.EachClientEachOrder$, this.searchInputComponent.valueChanges.pipe(startWith('')), this.allProductsRecord$]).pipe(
			map(([eachClientEachOrder, productSearch, allProductsRecord]) => {
				if (!productSearch) {
					return eachClientEachOrder;
				}

				eachClientEachOrder = genericSearchingFunctionWithoutNullChecks(productSearch, eachClientEachOrder, ['DocItemName', 'DocItemCode']);

				for (const order of eachClientEachOrder) {
					order.ItemPicName ||= allProductsRecord[order.DocItemCode]?.ItemPicName;
				}

				return eachClientEachOrder;
			}),
		);
	}

	getEachClientEachOrder() {
		if (this.mismachim.length) {
			this.EachClientEachOrder = this.mismachim;
			this.EachClientEachOrder$.next(this.EachClientEachOrder);
			this.Client_Name = this.EachClientEachOrder[0].Client_Name;
			this.Client_Id = this.EachClientEachOrder[0].DocCustCode;
			this.ClientEmail = '';
			this.markAndSetUpInitialValues();
			return;
		}

		this._ss.GetOneTeudaAgentNew(this._mismachim.chosenMismachParameters, this._ss.OneClientInfo.company).subscribe(res => {
			if (typeof res === 'string') {
				alert('ישנה תקלת תקשורת, אנא נסה שנית או מאוחר יותר.');
				return;
			}

			if (!res.recordset?.length) return;

			this.EachClientEachOrder = res.recordset;
			this.EachClientEachOrder$.next(this.EachClientEachOrder);

			this.markAndSetUpInitialValues();
		});
	}

	markAndSetUpInitialValues() {
		this.markProductsWithItemPicName();

		if (this.canDuplicate) {
			const { DocCustCode, AgentId, Company, DocCreateDate, DocDocNum, DocDocType } = this.EachClientEachOrder[0];
			this._ss.getAllDuplicateRowsForTeuda({ Client_Id: DocCustCode, AgentId, company: Company, TeudaCreateDate: DocCreateDate, TeudaNum: DocDocNum }).subscribe({
				next: res => {
					if (typeof res === 'string') {
						alert('ישנה תקלת תקשורת, אנא נסה שנית או מאוחר יותר.');
						return;
					}

					const relevantRows = res.recordset.filter(row => row.TeudaType === DocDocType);

					this.doctypes$.next(relevantRows);
				},
				error: err => {
					console.error(err);
				},
			});
		}

		if (localStorage.getItem('AllDocTypesSave') !== null) {
			const AllDocTypesSave = JSON.parse(decompress(localStorage.getItem('AllDocTypesSave')));

			const { DocCustCode: Client_Id, Company: company } = this.EachClientEachOrder[0];

			console.log(AllDocTypesSave[0]);

			const doctypeNames = AllDocTypesSave.reduce((acc, row) => {
				if (row.Company == company && row.ClientID == Client_Id) {
					acc[row.DocType] = row.DocName;
				}
				return acc;
			}, {});

			console.log(doctypeNames);

			this.doctypeNames$.next(doctypeNames);
		}

		if (this._ss.CustomerInformation.CanSendEmail_AgentsSendInvoice && this._ss.CustomerInformation.CanSendEmail_AgentsSendInvoice !== '0') {
			const agents = this._ss.CustomerInformation.CanSendEmail_AgentsSendInvoice.split('_');

			if (!agents.includes(this._ss.AgentIdConnected)) {
				return;
			}
		}

		if (this._ss.CustomerInformation.CanSendEmail && this._ss.CustomerInformation.CanSendEmail.includes('4') && this.EachClientEachOrder?.[0]?.DocPicName) {
			this._ss.checkIfPDFExistInServer(this.pdfFolderLookup, this.EachClientEachOrder?.[0]?.DocPicName).subscribe({
				next: (value: any) => {
					this.doesPDFExistInServer = true;
					this.pdfFilepath = this.formatStringWithEncodedSlashes(value.pdf);
				},
			});
		}

		this.doctypeName = this.EachClientEachOrder[0].DocTypeName ?? 'אסמכתא';
	}

	formatStringWithEncodedSlashes(str: string) {
		return str.replace(/\//g, '%2F').replace(/\\/g, '%5C');
	}

	handleClosePopup() {
		this.isEmailPickPopupOpen = this.emailSentSuccessfully = false;
	}

	loadingEmailSend = false;
	emailSentSuccessfully = false;

	handleSubmitEmail() {
		this.loadingEmailSend = true;

		let email = '';

		switch (this.emailRadios.value) {
			case 'client':
				email = this.OneClientInfo.CustEmail || this.OneClientInfo.CustEMail;
				break;
			case 'user':
				email = this._user.agentEmail$.value;
				break;
			case 'custom':
				email = this.emailInput.value;
				break;

			default:
				break;
		}

		this._ss.sendPDFThroughEmail(email, this.pdfFilepath, this.EachClientEachOrder[0].DocDocNum).subscribe({
			next: res => {
				this.loadingEmailSend = false;
				this.emailSentSuccessfully = true;
			},
			error: err => {
				alert('ישנה תקלת תקשורת, אנא נסה שנית או מאוחר יותר.');
				this.loadingEmailSend = false;
			},
		});
	}

	markProductsWithItemPicName() {
		this.allProductsRecord$.pipe(take(1)).subscribe(allProductsRecord => {
			for (const product of this.EachClientEachOrder$.value) {
				product.ItemPicName ||= allProductsRecord[product.DocItemCode]?.ItemPicName;
			}
		});
	}

	public BackToMismachim() {
		this.router.navigate(['mismachim']);
	}

	public DuplicateOrder(Doc: typeof this.doctypeDisplay$ extends Observable<Array<infer T>> ? T : never) {
		const AllOrder = [];

		const clientID = Doc.lines[0].Client_Id;
		const Type = Doc.doctype;
		const company = Doc.lines[0].Company;

		const newDate = new Date();

		for (let x = 0; x < Doc.lines.length; x++) {
			const original = Doc.lines[x];
			const order: Partial<Order> = {
				Stock: original.Stock,
				ProductId: original.ProductId,
				Product_Name: original.Product_Name,
				Price: original.NetPrice,
				PermPrice: original.PermPrice,
				ItemPack: original.ItemPack,
				TeudaQuantity: original.TeudaQuantity,
				TeudaPackQuantity: original.TeudaPackQuantity,
				TeudaBonusQuantity: original.TeudaBonusQuantity,
				YehidotPrice: original.TeudaQuantity * original.NetPrice,
				ArizotPrice: original.TeudaPackQuantity * original.ItemPack * original.NetPrice,
				NetPrice: original.NetPrice,
				ItemBarcode: original.ItemBarcode,
				TeudaItemRemark: '',
				TeudaRemark: '',
				ChangePrice: original.ChangePrice,
				ChangeDiscount: original.Discount,
				ItemPicName: original.ItemPicName,
				BD: original.BD,
				BP: original.BP,
				BM: original.BM,
				BS: original.BS,
				MinPrice: original.MinPrice,
				qt: original.qt,
				PKD: +original.PKD,
				CPP: original.CPP,
				Ptve: this._ss.VersionNumber,
				TeudaTotalRow: original.NetPrice * original.TotalQty,
				Duplicate: 'false',
				DuplicateOrder: 'true',
				IfChangePriceOrDisc: OrderState.changedBothDiscountAndPrice,
				PriceInInput: original.PriceInInput,
				TeudaNum: newDate.getTime() + '000' + this._ss.AgentIdConnected,
				TeudaCreateDate: newDate.toISOString(),
				TeudaNumDupFrom: original.TeudaNum,
			};

			AllOrder.push(order);
		}

		localStorage.setItem('AllOrder' + clientID + Type + company, JSON.stringify(AllOrder));

		this.ConfirmPop = true;
		this.PopDuplicate = false;
	}

	public Exit() {
		this.ConfirmPop = false;
	}

	public WatchOrderDuplicate() {
		this.router.navigate(['clients']);
	}
}
